import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Helmet } from "react-helmet";
import InternalRight from "./components/internalRight/index";
import "./App.css";

const OnbordingPage = ({ siteName, testMode = false }) => {
  return (
    <>
      <Helmet>
        <title>
          {testMode
            ? "RestoGPT internal test (no Slack)"
            : "RestoGPT AI: Launch in 24 hours"}
        </title>
      </Helmet>
      <div className="wraper internal-form-page">
        <Container fluid>
          <Row>
            <Col className="p-0" lg="12">
              <InternalRight siteName={siteName} testMode={testMode} />
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default OnbordingPage;
